module.exports = __webpack_public_path__ + "img/info-card-2.668c3370.jpg";